// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSharedEmailAddressUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSharedEmailAddressUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSharedEmailAddressUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorSharedEmailAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "emailAddressId",
        "baseName": "emailAddressId",
        "type": "number"
    },
    {
        "name": "emailAddressType",
        "baseName": "emailAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    }
];
//# sourceMappingURL=enterpriseCoordinatorSharedEmailAddressUpsearchModel.js.map